import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
export function ContextQualification() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-50" data-id="element-538">
      <div className="max-w-7xl mx-auto" data-id="element-539">
        <div className="text-center mb-16" data-id="element-540">
          <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] mb-6 text-black" data-id="element-541">
            This Is For Organizations Where <br data-id="element-542" />
            <span className="text-[#0066FF]" data-id="element-543">
              Context = Competitive Advantage
            </span>
          </h2>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl border-t-4 border-[#0066FF] shadow-lg max-w-4xl mx-auto mb-12" data-id="element-544">
          <h3 className="text-2xl font-bold font-['Syne'] mb-8 text-black" data-id="element-545">
            You need context engineering if:
          </h3>
          <div className="space-y-4" data-id="element-546">
            <QualItem text="Your outputs require institutional knowledge AI doesn't have" data-id="element-547" />
            <QualItem text="Compliance boundaries aren't negotiable" data-id="element-548" />
            <QualItem text="Quality consistency separates you from competitors" data-id="element-549" />
            <QualItem text="Your institutional intelligence is too valuable to keep in expert heads" data-id="element-550" />
          </div>
        </div>

        <div className="text-center" data-id="element-551">
          <Link to="/contact" onClick={scrollToTop} className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105" data-id="element-552">
            TALK TO OUR TEAM
            <ArrowRight className="w-5 h-5" data-id="element-553" />
          </Link>
        </div>
      </div>
    </section>;
}
function QualItem({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-4" data-id="element-554">
      <div className="mt-1 flex-shrink-0" data-id="element-555">
        <Check className="w-5 h-5 text-[#0066FF]" data-id="element-556" />
      </div>
      <p className="text-lg leading-relaxed text-gray-700" data-id="element-557">{text}</p>
    </div>;
}